import { useAuth } from '@/auth/Auth';
import InsideRoutes from './InsideRoutes';
import OutsideRoutes from './OutsideRoutes';
import Loader from '@/components/Loader/Loader';
import { Cookies } from 'react-cookie';

export default function Routes() {
  const { authData, token, loading } = useAuth();

  const cookies = new Cookies();

  const mundpayLoginByImp = cookies.get('mundpay_login_by_imp') === 'true';

  const isAuthenticated = !!token && (!!authData || mundpayLoginByImp);
  const isEmailVerified = !!authData?.email_verified_at;

  if (loading) {
    return (
      <div className='flex items-center justify-center w-full h-screen'>
        <Loader />
      </div>
    );
  }

  const routes =
    isAuthenticated && (isEmailVerified || mundpayLoginByImp) ? (
      <InsideRoutes />
    ) : (
      <OutsideRoutes />
    );
  return routes;
}